import { useApolloClient } from "@apollo/client";
import { CustomFieldObjectType } from "../../../clients/graphqlTypes.js";
import { useCustomFieldConfigQuery } from "./customFieldConfigs.generated.js";

export const useCustomFieldConfig = (objectType?: CustomFieldObjectType) => {
  const client = useApolloClient();
  const query = useCustomFieldConfigQuery({
    client,
    variables: { filterObjectType: objectType },
  });
  return {
    customFieldConfig: query.data?.customFieldConfig ?? [],
    loading: query.loading,
    error: query.error,
  };
};
